import { router } from '@inertiajs/react'
import { EditStream } from '@/components/streams'
import type { StreamDetail, SourceTypeOption, GemCriteriaTemplate } from '@/types/streams'

interface StreamsEditPageProps {
  stream: StreamDetail
  sourceTypeOptions: SourceTypeOption[]
  gemCriteriaTemplates?: GemCriteriaTemplate[]
}

export default function StreamsEditPage({ stream, sourceTypeOptions, gemCriteriaTemplates = [] }: StreamsEditPageProps) {
  const handleViewItems = () => {
    router.visit(`/streams/${stream.id}/items`)
  }

  const handleViewReports = () => {
    router.visit(`/reports?stream_id=${stream.id}`)
  }

  const handleSave = (updatedStream: StreamDetail) => {
    router.patch(`/streams/${stream.id}`, {
      stream: {
        name: updatedStream.name,
        description: updatedStream.description,
        status: updatedStream.status,
        report_subscriber_ids: updatedStream.reportSubscriberIds,
        sources_attributes: updatedStream.sources.map((s) => ({
          id: s.id.startsWith('src-') ? undefined : s.id,
          source_type: s.type,
          label: s.label,
          _destroy: false,
        })),
        questions_attributes: updatedStream.questions.map((q, index) => ({
          id: q.id.startsWith('q-') ? undefined : q.id,
          text: q.text,
          description: q.description,
          response_format: q.responseFormat,
          position: index + 1,
          _destroy: false,
        })),
        gem_criteria_attributes: updatedStream.gemCriteria.map((gc) => ({
          id: gc.id.startsWith('gc-') ? undefined : gc.id,
          title: gc.title,
          description: gc.description,
          notify_immediately: gc.notifyImmediately,
          subscriber_ids: gc.subscriberIds || [],
          _destroy: false,
        })),
      },
    }, {
      preserveState: false,
    })
  }

  const handleCancel = () => {
    router.visit('/streams')
  }

  const handleDelete = () => {
    router.delete(`/streams/${stream.id}`)
  }

  const handleToggleStatus = () => {
    router.patch(`/streams/${stream.id}/toggle_status`, {}, {
      preserveState: true,
      onSuccess: () => {
        // Status will be updated in props from server
      },
    })
  }

  const handleUploadCsv = () => {
    router.visit(`/items/upload?stream_id=${stream.id}`)
  }

  return (
    <EditStream
      stream={stream}
      sourceTypeOptions={sourceTypeOptions}
      gemCriteriaTemplates={gemCriteriaTemplates}
      onViewReports={handleViewReports}
      onSave={handleSave}
      onCancel={handleCancel}
      onDelete={handleDelete}
      onToggleStatus={handleToggleStatus}
      onUploadCsv={handleUploadCsv}
    />
  )
}
